<template>
  <div v-loading="loading">
    <div class="header">
      <el-space>
        <el-input
            v-model="search"
            style="width: 250px;"
            placeholder="Izlash"
            clearable
            @clear="onSearch"
        >
          <template #append>
            <el-button style="display: flex" @click="onSearch"
            ><img src="@/assets/images/icons/search.svg" alt=""/>
            </el-button>
          </template>
        </el-input>
        <el-select
            v-model="category_id"
            placeholder="Tashabbus kategoriyasi"
            filterable
            clearable
            @change="onChangeCategory"
            @clear="onChangeCategory"
        >
          <el-option
              v-for="category in categories"
              :value="category.id"
              :key="category.id"
              :label="category.title"
          />
        </el-select>
        <el-select v-model="board_id" style="width: 280px" @change="onchangeBoard">
          <el-option
              v-for="board in boards"
              :key="board.id"
              :value="board.id"
              :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil'
              "
          />
        </el-select>
      </el-space>
      <!-- Toolbar (§6.1): one primary action ("Qo'shish"); the three import
           actions grouped under a single "Import ▾" dropdown; export as a plain
           secondary button. No bare text links, no one-off accent colors,
           consistent heights. Per-action loading/success/error feedback. -->
      <el-space :size="12">
        <!-- Import dropdown stays open even when the write window is closed so
             the read-only helpers (template download, ID modal) remain reachable;
             only the upload item is disabled (§4). -->
        <el-dropdown trigger="click" :disabled="importBusy" @command="onImportCommand">
          <el-button :icon="Upload" :loading="importBusy">
            Import<el-icon class="el-icon--right"><ArrowDown/></el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="upload" :icon="Upload" :disabled="windowClosed">
                Excel yuklash
              </el-dropdown-item>
              <el-dropdown-item command="template" :icon="Download">Shablon yuklab olish</el-dropdown-item>
              <el-dropdown-item command="ref" :icon="List">Turkum ID'lari</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-button :icon="Download" :loading="exporting" @click="getExcell()">Excel olish</el-button>
        <el-tooltip
            content="Review boshlangan — o'zgartirish yopiq"
            :disabled="!windowClosed"
        >
          <span>
            <el-button
                type="primary"
                :icon="Plus"
                :disabled="windowClosed"
                @click="$router.push({ name: 'ProductsAdd' })"
            >
              Qo'shish
            </el-button>
          </span>
        </el-tooltip>
      </el-space>
      <!-- Hidden input backing the "Excel yuklash" dropdown item (§6.1). -->
      <input
          ref="fileInput"
          type="file"
          accept=".xlsx,.xls"
          style="display: none"
          @change="onFileSelected"
      />
    </div>
    <el-alert
        class="import-note"
        type="info"
        show-icon
        :closable="false"
        title="Import faqat YANGI tovar qo'shadi, mavjudlarini yangilamaydi — mavjud tovarni tahrirlash uchun uni ro'yxatda oching."
    />
    <!-- Write window closed for the selected board — review period started, so
         the product list is view-only (FRONTEND_PRODUCT_WRITE_WINDOW.md §4). -->
    <el-alert
        v-if="windowClosed"
        class="window-note"
        type="warning"
        show-icon
        :closable="false"
        title="Bu mavsum uchun review davri boshlangan — tovarlar ro'yxatini o'zgartirib bo'lmaydi (faqat ko'rish mumkin)."
    />

    <el-dialog v-model="categoryRefVisible" title="Turkum ID'lari" width="560px">
      <p class="ref-hint">
        Excel faylning «Initiative_category_id» ustuniga shu yerdagi ID raqamini nusxalang.
      </p>
      <!-- Search once the list gets long enough to scroll-hunt (§3.5). -->
      <el-input
          v-if="equipableCategories.length > 8"
          v-model="refSearch"
          class="ref-search"
          placeholder="Nomi bo'yicha izlash"
          clearable
      />
      <el-table :data="filteredRefCategories" height="360" border>
        <el-table-column prop="id" label="ID" width="90">
          <template #default="scope">
            <span class="cat-id">{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="Nomi"/>
        <el-table-column label="" width="120" align="center">
          <template #default="scope">
            <!-- v2: copy the ID (not the name); swap to a checkmark ~1.5s. -->
            <el-button
                link
                type="primary"
                :icon="copiedId === scope.row.id ? CircleCheck : CopyDocument"
                @click="copyId(scope.row.id)"
            >{{ copiedId === scope.row.id ? "Nusxalandi" : "Nusxa" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-table
        class="table-body"
        :data="tableData"
        border
        height="calc(100vh - 247px)"
    >
      <el-table-column type="index" label="T/r" :index="indexMethod"/>
      <el-table-column label="Tashabbus kategoriyasi">
        <template #default="scope">
          <span v-if="scope.row.initiative_category">{{ scope.row.initiative_category }}</span>
          <el-tag v-else size="small" type="info" effect="plain">Turkum yo'q</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="Nomi"/>
      <el-table-column prop="price" label="Narxi"/>
      <el-table-column prop="max_available" label="Soni"/>
      <el-table-column prop="unit_of_measure" label="O'chov birligi"/>
      <el-table-column align="center">
        <template #default="scope">
          <!-- Both row actions frozen once the board's review window is closed
               (§4); tooltip explains why rather than hiding them. -->
          <el-tooltip content="Review boshlangan — o'zgartirish yopiq" :disabled="!windowClosed">
            <span>
              <el-button
                  size="small"
                  type="danger"
                  :disabled="windowClosed"
                  @click="deleteBudgetParam(scope.row.id)"
              >O'chirish
              </el-button>
            </span>
          </el-tooltip>
          <el-tooltip content="Review boshlangan — o'zgartirish yopiq" :disabled="!windowClosed">
            <span>
              <el-button
                  size="small"
                  type="primary"
                  :disabled="windowClosed"
                  @click="
                  $router.push({
                    name: 'ProductsEdit',
                    params: { id: scope.row.id },
                  })
                "
              >Tahrirlash
              </el-button>
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span v-if="totalElements">Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              layout=" prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import {ArrowDown, Upload, Download, Plus, List, CircleCheck, CopyDocument} from "@element-plus/icons-vue";
import http from "@/http";

export default {
  name: "ProductsList",
  components: {ArrowDown},
  data() {
    return {
      // icons referenced in template attributes (:icon="...")
      Upload,
      Download,
      Plus,
      List,
      CircleCheck,
      CopyDocument,
      loading: false,
      tableData: [],
      categories: [],
      category_id: "",
      search: "",
      baseUrl: process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/",
      board_id: null,
      boards: [],
      categoryRefVisible: false,
      refSearch: "",
      copiedId: null,
      uploading: false,
      downloadingTemplate: false,
      exporting: false,
      // Set by a 451 backstop so a proven-closed write locks the screen even if
      // the client clock disagrees with the board's review_start_date (§4.5).
      forcedClosed: false,

      totalElements: 0,
      totalPages: null,
      size: 20,
      page: 1,
    };
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
    // The "Import ▾" button spins while any import-side action is in flight
    // (upload or template download) and blocks re-entry (§6.1 item 4).
    importBusy() {
      return this.uploading || this.downloadingTemplate;
    },
    // v2: the reference modal must offer ONLY active + equipable categories —
    // an id copied from here must always import successfully (§3.5). String
    // compare ("0" is truthy in JS).
    equipableCategories() {
      return this.categories.filter(
          (c) => c.is_active === "1" && c.is_equipable === "1"
      );
    },
    filteredRefCategories() {
      const q = this.refSearch.trim().toLowerCase();
      if (!q) return this.equipableCategories;
      return this.equipableCategories.filter((c) =>
          (c.title || "").toLowerCase().includes(q)
      );
    },
    selectedBoard() {
      return this.boards.find((b) => b.id === this.board_id) || null;
    },
    // v2 (FRONTEND_PRODUCT_WRITE_WINDOW.md §4): the admin product list is
    // write-frozen once the selected board's REVIEW period starts — no add,
    // edit, delete or Excel import; reads/exports stay open. Compare instants
    // (review_start_date carries a timezone offset). Fail open if the date is
    // absent so a missing field never falsely locks the screen — the 451
    // backstop still covers it.
    windowClosed() {
      if (this.forcedClosed) return true;
      const start = this.selectedBoard?.review_start_date;
      if (!start) return false;
      return Date.now() >= new Date(start).getTime();
    },
  },
  methods: {
    onChangeCategory() {
      this.$router
          .replace({
            query: {...this.$route.query, page: 1},
          }).then(() => {
        this.getProducts();
      }).catch(() => {
      });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          }).then(() => {
        this.getProducts();
      }).catch(() => {
      });
    },
    onchangeBoard() {
      // A different board has its own window — drop any forced-closed lock so
      // it is re-derived from the newly selected board's review_start_date.
      this.forcedClosed = false;
      this.$router
          .replace({
            query: {...this.$route.query, page: 1},
          }).then(() => {
        this.getProducts();
      }).catch(() => {
      });
    },
    // A write blocked by the review window returns 451 / board_window_closed
    // (FRONTEND_PRODUCT_WRITE_WINDOW.md §4.5) — the UI backstop.
    isWindowClosedError(response) {
      return (
          response?.status === 451 &&
          response?.data?.specific_slug === "board_window_closed"
      );
    },
    handleWindowClosed(response) {
      this.forcedClosed = true;
      ElNotification({
        type: "warning",
        title: "Yopiq",
        message:
            response?.data?.message ||
            "Review boshlangan — tovarlar ro'yxatini o'zgartirib bo'lmaydi.",
        duration: 0,
      });
    },
    getBoards() {
      this.loading = true;
      http({url: `api/v1/boards`, params: {status: 1}})
          .then(({data}) => {
            this.boards = data.boards;
            this.board_id = data.boards[0].id;
            if (this.board_id) {
              this.getProducts();
            }
          })
          .catch((err) => {
            ElMessage.error(
                err.response.data.message || `Hatolik qayta urinib ko'ring`
            );
            this.loading = false;
          })
    },
    onSearch() {
      this.$router
          .replace({
            query: {...this.$route.query, page: 1},
          }).then(() => {
        this.getProducts();
      }).catch(() => {
      });
    },
    getExcell() {
      this.exporting = true;
      http
          .get("api/v1/products/excel", {
            params: {
              board_id: this.board_id,
            },
            responseType: 'blob'
          })
          .then((response) => {
            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "tovarlar.xlsx"); // or dynamically set the filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            ElMessage({
              type: "success",
              message: "Muvaffaqqiyatli yuklandi",
            });
          })
          .catch(({response}) => {
            ElNotification.error({
              message: response.data.message || "Xatolik sodir bo'ldi!",
            });
          })
          .finally(() => {
            this.exporting = false;
          });
    },
    // Import dropdown (§6.1): upload a filled file / download the blank template
    // / open the ID reference modal.
    onImportCommand(command) {
      if (command === "upload") {
        if (!this.board_id) {
          ElMessage.warning("Avval doskani tanlang");
          return;
        }
        this.$refs.fileInput.click();
      } else if (command === "template") {
        this.getTemplate();
      } else if (command === "ref") {
        this.categoryRefVisible = true;
      }
    },
    // Upload the chosen workbook to /products/sync-excel. The shared `http`
    // instance forces application/json, so override transformRequest for this
    // one call: keep the auth header but let the browser set the multipart
    // Content-Type (with boundary) itself.
    onFileSelected(event) {
      const input = event.target;
      const file = input.files && input.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append("board_id", this.board_id);
      formData.append("file", file);
      this.uploading = true;
      const token = this.$store.state.accessToken;
      http({
        url: "api/v1/products/sync-excel",
        method: "post",
        data: formData,
        transformRequest: [
          (data, headers) => {
            headers["Authorization"] = token;
            delete headers["Content-Type"];
            return data;
          },
        ],
      })
          .then(() => {
            ElMessage.success("Import muvaffaqiyatli yakunlandi");
            this.getProducts();
          })
          .catch(({response}) => {
            // Closed review window → lock the screen (§4.5). The file is
            // rejected before any row is processed, so there's no partial import.
            if (this.isWindowClosedError(response)) {
              this.handleWindowClosed(response);
              return;
            }
            // Otherwise surface the backend's exact message verbatim (§3.2/§3.5)
            // — it names the offending value (bad id, non-numeric cell,
            // non-equipable category) or "incorrect title row" for old 6-column
            // / v1 title-based files, letting the admin self-correct.
            ElNotification({
              type: "error",
              title: "Import xatoligi",
              message: response?.data?.message || "Iltimos, qayta urinib ko'ring",
              duration: 0,
            });
          })
          .finally(() => {
            this.uploading = false;
            input.value = ""; // allow re-selecting the same file
          });
    },
    // Blank 5-column import template from the dedicated endpoint — never the
    // export (§3.4). No board_id needed; shape never drifts from the importer.
    getTemplate() {
      this.downloadingTemplate = true;
      http
          .get("api/v1/products/excel-template", {responseType: "blob"})
          .then((response) => {
            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Products-import-template.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            ElMessage.success("Shablon yuklab olindi");
          })
          .catch(({response}) => {
            ElNotification.error({
              message: response?.data?.message || "Shablonni yuklashda xatolik",
            });
          })
          .finally(() => {
            this.downloadingTemplate = false;
          });
    },
    // v2: the reference modal is now ID-based — copy the category ID (not the
    // name), with a ~1.5s checkmark confirmation (§3.5).
    copyId(id) {
      const text = String(id);
      navigator.clipboard?.writeText(text).then(
          () => {
            this.copiedId = id;
            ElMessage.success("ID nusxalandi");
            clearTimeout(this._copyTimer);
            this._copyTimer = setTimeout(() => {
              this.copiedId = null;
            }, 1500);
          },
          () => ElMessage.error("Nusxa olishda xatolik")
      );
    },
    getProducts() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.$http
          .get(
              `api/v1/products`,
              {
                params: {
                  // Unified filter — products bind directly to an
                  // initiative_category now (§1.2, §2.4). The old
                  // category_id (product_category) filter is retired.
                  initiative_category_id: this.category_id || undefined,
                  search: this.search,
                  board_id: this.board_id,
                  limit: this.size,
                  offset: (this.page - 1) * this.size
                }
              }
          )
          .then(({data}) => {
            this.tableData = data.products;
            this.totalElements = data.count;
            this.totalPages = Math.ceil(data.count / this.size);
            this.tableData.forEach((product) => {
              if (product.unit_of_measure === "collection") {
                product.unit_of_measure = "To'plam";
              }
              if (product.unit_of_measure === "piece") {
                product.unit_of_measure = "Dona";
              }
              if (product.unit_of_measure === "package") {
                product.unit_of_measure = "Quti";
              }
            });
          })
          .catch(({response}) => {
            ElNotification.error({
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },

    deleteBudgetParam(id) {
      ElMessageBox.confirm("Parametrni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`api/v1/products/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Muvaffaqqiyatli o'chirildi",
                  });
                  this.getProducts();
                })
                .catch(({response}) => {
                  // Review window closed → lock the screen (§4.5).
                  if (this.isWindowClosedError(response)) {
                    this.handleWindowClosed(response);
                    return;
                  }
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: response?.data?.message || "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },

    indexMethod(index) {
      return index + (this.currentPage - 1) * this.size + 1;
    },
  },
  mounted() {
    this.getBoards()

    // Filter + Excel-reference options share the citizen picker's source of
    // truth — initiative categories, not the legacy product-categories (§4).
    http
        .get("api/v1/initiative-categories", {params: {is_active: 1, limit: 1000}})
        .then((res) => {
          this.categories = res.data.initiative_categories || [];
        })
        .catch(() => {
          ElMessage.error("Kategoriyalarni yuklashda xatolik");
        });
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 20px;

  .filter {
    display: flex;
    justify-content: flex-start;
  }
}

.table-body {
  img {
    width: 80px;
  }
}

.import-note {
  margin-bottom: 10px;
}

.window-note {
  margin-bottom: 10px;
}

.ref-hint {
  margin: 0 0 12px;
  color: #606266;
  font-size: 13px;
}

.ref-search {
  margin-bottom: 12px;
}

.cat-id {
  font-family: "Courier New", monospace;
  font-weight: 700;
  color: #0A194E;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}

.pagination-wrapper > span {
  color: #0A194E;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
